import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";
import { useCallback, useMemo, useState } from "react";
import AddCompanySteps from './components/tabs'
import AddCompanyTabContent from './components/tabs-content'
import { steps } from "./initiator";
import KYBCompanyContext from "./contexts/KYBCompanyContext";
import { useQueries } from "@tanstack/react-query";
import CancelConfirmationModal from "./components/CancelConfirmationModal";
import KYBService from "src/modules/3rd-party-management/apis/admin/KYBService";

const AddCompany = ({
    supplierData
}) => {
    const [ companyData, setCompanyData ] = useState({
        name: supplierData?.name || '',
        shortName: supplierData?.shortName || '',
        registrationNumber: supplierData?.registrationNumber || '',
        country: supplierData?.country || '',
        services: [],
        reports: {}
    });
    const [ showCancelConfirmModal, setShowCancelConfirmModal ] = useState(false);
    const [ tab, setTab ] = useState('search-item');

    const queriesBody = useMemo(() => {
        const result = [];
        const selectedReports = [];

        companyData.services.forEach((service) => {
            (companyData.reports[service] || []).forEach((serviceReport) => {
                result.push({
                    queryKey: [
                        '3rd-party-management-kyb-fetch-organization-from-provider', 
                        supplierData.id,
                        service,
                        serviceReport.id
                    ],
                    queryFn: async () => {
                        const kybServiceObj = KYBService.getInstance();

                        return await kybServiceObj.fetchOrgFromProvider(serviceReport.id, {
                            provider: service,
                            supplier_id: supplierData.id
                        });
                    },
                    refetchOnWindowFocus: false,
                    enabled: false,
                    retry: 0
                });

                selectedReports.push({
                    reportId: `${service}-${serviceReport.id}`,
                    serviceId: service
                });
            });
        });

        return {
            result: result,
            selectedReports: selectedReports
        };
    }, [ 
        supplierData.id,
        companyData.reports,
        companyData.services
    ]);

    const queries = useQueries({
        queries: queriesBody.result
    });

    const queriesResults = useMemo(() => {
        return (queriesBody.selectedReports || []).map((selectedReport, index) => ({
            id: selectedReport.reportId,
            serviceId: selectedReport.serviceId,
            ...queries[index]
        }));
    }, [ 
        queriesBody.selectedReports,
        queries
    ]);

    const tabsToDisable = useMemo(() => {
        return [];
    }, [ ]);

    const handleGoToNextTab = () => {
        const numberOfSteps = steps.length
        const currentStepIndex = steps.findIndex((step) => step.stepUniqueKey === tab)

        if (currentStepIndex < numberOfSteps - 1) {
            const nextStep = steps[currentStepIndex + 1]

            setTab(nextStep.stepUniqueKey)
        }
    }

    const handleGoPrevTab = () => {
        const currentStepIndex = steps.findIndex((step) => step.stepUniqueKey === tab)

        if (currentStepIndex > 0) {
            const prevStep = steps[currentStepIndex - 1]

            setTab(prevStep.stepUniqueKey)
        }
    }

    const handleGoToTab = (stepUniqueKey) => {
        setTab(stepUniqueKey)
    }

    const handleFetchReports = useCallback(() => {
        queries.forEach((query) => query.refetch());

        handleGoToTab('results');
    }, [ queries ]);

    const handleCancelButton = () => {
        setShowCancelConfirmModal(true);
    }

    return (
        <KYBCompanyContext.Provider 
            value={{
                supplierData,
                companyData,
                setCompanyData,
                handleFetchReports,
                fetchDetailsQueries: queriesResults
            }}
        >
            <div className='add-kyb-company'>
                <Row>
                    <Col sm="12">
                        <AddCompanySteps
                            activeTab={tab}
                            disabledTabs={tabsToDisable}
                        />
                    </Col>

                    <Col sm="12">
                        <AddCompanyTabContent
                            activeTab={tab}
                            onNextButtonClicked={handleGoToNextTab}
                            onBackButtonClicked={handleGoPrevTab}
                            onCancelButtonClicked={handleCancelButton}
                            goToTab={handleGoToTab}
                        />
                    </Col>
                </Row>

                <CancelConfirmationModal
                    isOpen={showCancelConfirmModal}
                    toggle={() => setShowCancelConfirmModal(false)}
                />
            </div>
        </KYBCompanyContext.Provider>
    );
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    const { Organization } = state;
    return {
        user: state.Login.user,
        token: token,
        organization: Organization
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(AddCompany))
);